import { ReactNode, PropsWithChildren, isValidElement } from 'react';

type Props = PropsWithChildren & { href: string };

const DefaultLink = ({ children, href }: Props) => <a href={href}>{children}</a>;

export const getExternalLinkFormatters = (CustomLink: (props: Props) => ReactNode) => ({
  ExternalLink: ([hrefChunk, ...chunks]: ReactNode[]) => {
    const resolveHref = (chunk: ReactNode): string => {
      if (typeof chunk === 'string') {
        return chunk;
      }
      if (Array.isArray(chunk)) {
        return chunk.map(resolveHref).join('');
      }
      if (isValidElement<{ ['data-href']?: ReactNode; children?: ReactNode }>(chunk)) {
        return resolveHref(chunk.props['data-href'] ?? chunk.props.children);
      }
      return '';
    };
    const href = resolveHref(hrefChunk);
    return <CustomLink href={href}>{chunks}</CustomLink>;
  },
  href: (chunks: ReactNode) => <div data-href={chunks} />,
});

export const externalLinkFormatters = getExternalLinkFormatters(DefaultLink);
